import actionBuilder from 'store/v2/actions';
import actionType, { bulkActionType, apiPath } from './constants';

export default actionBuilder({ apiPath, bulkActionType, actionType });
